import {
  SearchFormConfig,
  SearchFormFields,
  SearchFormTranslations,
} from '@awazevr/design-system.compositions.search-form'
import { GoogleSearchMethods } from '@awazevr/mfe-common.api.places-api'

export const FUSION_DATE_FORMAT = 'dd-MM-yyyy'
export const DISPLAY_DATE_FORMAT = 'd MMM'

export type environment = 'dev' | 'pprd' | 'prd'

export interface FormData {
  id?: string
  adult: string
  child: string
  destination?: string
  destinationCategory?: string
  destinationId?: string
  destinationURL?: string
  featureId?: string
  infant: string
  nights: string
  pets: string
  range: string
  start?: string
  minPrice?: number
  maxPrice?: number
  accommodationType?: string
  placesId?: string
  radiusCentre?: string | null
}

export interface SearchFormSubmitData extends FormData {
  ne?: string
  sw?: string
  features?: string[]
  siteFeatures?: string[]
}

export interface SearchFormProps {
  defaultConfig: SearchFormConfig
  initialValues: SearchFormFields
  openFilters: () => void
  translations?: SearchFormTranslations
  locale: string
  marketCode: string
  mobileStickyMode?: boolean
  placesConfig?: PlacesSearchConfigType
  isGuestApp?: boolean
}

export type DestinationListResult = {
  drupalId: string
  has_children: boolean
  houses: number
  id: number
  name: string
  parentId: number
  t: boolean
}

export type PlacesSearchConfigType = {
  useLegacyDestinationSelector: boolean
  initialParentDestinationList: string | undefined
  pageSize: number | undefined
  pageSizePopular: number | undefined
  googleFallbackMethod: GoogleSearchMethods
}

export type Suggestion = {
  id: string
  name: string
  link: string
  subtitle?: string
  parentName?: string
  countryName?: string
  type?: string
}
export type PlacesSuggestions = (searchTerm: string) => Promise<Suggestion[]>
